import { Dispatch, SetStateAction, useCallback } from 'react';
import { executeGroupMergeAction } from '@/components/action-buttons/group-merge.action';
import type { GroupMergePayload } from '@/components/action-buttons/use-group-merge-modal-orchestration';

type MergeGroupsResponse = {
    data: {
        targetGroupId: string;
    };
};

type UseGroupMergeActionArgs = {
    setPickedGroupIds?: (val: string[]) => void;
    refetchReviewsAndProducts: () => Promise<void>;
    setIsGroupsMergeLoading: Dispatch<SetStateAction<boolean>>;
    mergeGroups: (payload: GroupMergePayload) => Promise<MergeGroupsResponse>;
    syncSelectionAfterMerge?: () => Promise<void>;
};

type UseGroupMergeActionReturn = {
    groupPicked: (payload: GroupMergePayload) => Promise<boolean>;
};

export const useGroupMergeAction = ({
    setPickedGroupIds,
    refetchReviewsAndProducts,
    setIsGroupsMergeLoading,
    mergeGroups,
    syncSelectionAfterMerge,
}: UseGroupMergeActionArgs): UseGroupMergeActionReturn => {
    const groupPicked = useCallback(
        ({ groupIds, name }: GroupMergePayload) =>
            executeGroupMergeAction({
                groupIds,
                name,
                setIsGroupsMergeLoading,
                setPickedGroupIds,
                mergeGroups,
                syncSelectionAfterMerge,
                refetchReviewsAndProducts,
            }),
        [mergeGroups, refetchReviewsAndProducts, setIsGroupsMergeLoading, setPickedGroupIds, syncSelectionAfterMerge],
    );

    return {
        groupPicked,
    };
};
